import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';

import Tappable from 'react-tappable';

export default React.createClass({
  render() {
    return (
      <Tappable
        onTap={() =>
          CuesheetResponsiveActions.showRowMenuModalFor(this.props.rowIndex)
        }
      >
        <div className="csr-cog-wrapper">
          <Icon name="gear" size={2} />
        </div>
      </Tappable>
    );
  },
});
